import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import ComingSoon from '@app/components/presentational/ComingSoon';
import HomePage from './HomePage';

const HomeToggle = () => {
  const { webAppFtHomePageEnableFlag202605 } = useFlags();

  if (webAppFtHomePageEnableFlag202605) {
    return <HomePage />;
  }

  return <ComingSoon />;
};

export default HomeToggle;
